import React from 'react';
import { Wine, Sparkles, TrendingUp, Award } from 'lucide-react';
export function HomeScreen() {
  const stats = [{
    label: 'Bottiglie',
    value: '127',
    icon: Wine,
    color: '#6C083B'
  }, {
    label: 'Esperienze',
    value: '24',
    icon: Sparkles,
    color: '#6C083B'
  }, {
    label: 'Valore',
    value: '€8.4K',
    icon: TrendingUp,
    color: '#6C083B'
  }, {
    label: 'Top Rated',
    value: '15',
    icon: Award,
    color: '#6C083B'
  }];
  const recentBottles = [{
    id: 1,
    name: 'Barolo Riserva',
    producer: 'Gaja',
    year: 2016,
    image: '🍷'
  }, {
    id: 2,
    name: 'Brunello di Montalcino',
    producer: 'Biondi Santi',
    year: 2017,
    image: '🍷'
  }, {
    id: 3,
    name: 'Franciacorta Satèn',
    producer: 'Bellavista',
    year: 2018,
    image: '🥂'
  }];
  return <div className="h-full overflow-y-auto bg-white" data-id="element-235">
      <div className="px-5 py-6" data-id="element-236">
        <h2 className="text-2xl font-medium text-gray-900 mb-1" data-id="element-237">
          Ciao, Fabio
        </h2>
        <p className="text-sm text-gray-500 mb-8" data-id="element-238">La tua cantina personale</p>

        {/* Stats Grid - Gray Border 1px */}
        <div className="grid grid-cols-2 gap-3 mb-8" data-id="element-239">
          {stats.map(stat => {
          const Icon = stat.icon;
          return <div key={stat.label} className="p-4 rounded-xl transition-colors" style={{
            border: '1px solid #E5E7EB',
            backgroundColor: '#FFFFFF'
          }} data-id="element-240">
                <div className="flex items-center justify-between mb-3" data-id="element-241">
                  <Icon size={18} style={{
                color: stat.color
              }} strokeWidth={1.5} data-id="element-242" />
                  <p className="text-xs text-gray-400 uppercase tracking-wide font-medium" data-id="element-243">
                    {stat.label}
                  </p>
                </div>
                <p className="text-2xl font-light text-gray-900" data-id="element-244">
                  {stat.value}
                </p>
              </div>;
        })}
        </div>

        {/* Recent Bottles */}
        <div className="mb-8" data-id="element-245">
          <div className="flex items-center justify-between mb-4" data-id="element-246">
            <h3 className="text-sm font-medium text-gray-900" data-id="element-247">
              Aggiunte recenti
            </h3>
            <button className="text-xs text-gray-500 hover:text-gray-900 transition-colors" data-id="element-248">
              Vedi tutte
            </button>
          </div>

          <div className="space-y-4" data-id="element-249">
            {recentBottles.map(bottle => <div key={bottle.id} className="flex items-center gap-3 py-3 border-b border-gray-100 last:border-0" data-id="element-250">
                <div className="text-2xl" data-id="element-251">{bottle.image}</div>
                <div className="flex-1 min-w-0" data-id="element-252">
                  <h4 className="text-sm text-gray-900 mb-0.5" data-id="element-253">
                    {bottle.name}
                  </h4>
                  <p className="text-xs text-gray-500" data-id="element-254">
                    {bottle.producer} · {bottle.year}
                  </p>
                </div>
                <button className="text-xs text-gray-500 hover:text-gray-900 transition-colors" data-id="element-255">
                  Dettagli
                </button>
              </div>)}
          </div>
        </div>

        {/* Quick Actions */}
        <div className="mb-6" data-id="element-256">
          <h3 className="text-sm font-medium text-gray-900 mb-4" data-id="element-257">
            Azioni rapide
          </h3>
          <div className="space-y-3" data-id="element-258">
            <button className="w-full flex items-center gap-3 py-3 border-b border-gray-100 text-left hover:border-gray-300 transition-colors" data-id="element-259">
              <Wine size={18} style={{
              color: '#6C083B'
            }} strokeWidth={1.5} data-id="element-260" />
              <div className="flex-1" data-id="element-261">
                <p className="text-sm text-gray-900 mb-0.5" data-id="element-262">Aggiungi vino</p>
                <p className="text-xs text-gray-500" data-id="element-263">
                  Scansiona o inserisci manualmente
                </p>
              </div>
            </button>

            <button className="w-full flex items-center gap-3 py-3 border-b border-gray-100 text-left hover:border-gray-300 transition-colors" data-id="element-264">
              <Sparkles size={18} style={{
              color: '#6C083B'
            }} strokeWidth={1.5} data-id="element-265" />
              <div className="flex-1" data-id="element-266">
                <p className="text-sm text-gray-900 mb-0.5" data-id="element-267">
                  Esplora esperienze
                </p>
                <p className="text-xs text-gray-500" data-id="element-268">
                  Scopri nuovi abbinamenti
                </p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>;
}